import { make } from 'vuex-pathify'

// API's
import Examenes from '@/api/promotores/examenes.api'

// Modules
import pregunta from './examen/pregunta.module';

const modules = {
    pregunta
}

const state = {

    // Almacena la seleccion individual del elemento
    // Facilita el acceso desde otros componentes.
    seleccion: {},
}

const mutations = make.mutations(state)

const actions = {
    /**
     * Get all examenes.
     * @param {Object} context 
     * @returns {Promise}
     */
    all(context) {
        return Examenes.all()
    },

    /**
     * Create a new examen
     * @param {Object} context
     * @param {Object} payload 
     * @returns {Promise}
     */
    add(context, payload) {
        return Examenes.add(payload)
    },

    /**
     * Get an examen
     * @param {Object} context 
     * @param {int} id 
     * @returns {Promise}
     */
    get(context, id) {
        return Examenes.get(id)
    },

    /**
     * Update an examen
     * @param {Object} context 
     * @param {Object} payload 
     * @returns {Promise}
     */
    update(context, { id, ...payload } ) {
        return Examenes.update(id, payload)
    },

    /**
     * Activate an examen
     * @param {Object} context 
     * @param {int} examen 
     * @returns {Promise}
     */
    publicar(context, examen) {
        return Examenes.activar(examen)
    },

    /**
     * Deactivate an examen
     * @param {Object} context 
     * @param {int} examen 
     * @returns {Promise}
     */
    no_publicar(context, examen) {
        return Examenes.desactivar(examen)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    modules,
}